const doc = [({"ko":({"adminConstantNewsletterStatus":({"created":"작성됨", "sending":"전송 중", "sent":"전송됨"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;